var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.title),expression:"title"}],staticClass:"status-icon pi",class:_vm.ok ? 'pi-check-circle status-icon--ok' : 'pi-times-circle status-icon--bad'})}
var staticRenderFns = []

export { render, staticRenderFns }